import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/frontend/src/app/page.tsx");
